module.exports = __webpack_public_path__ + "img/Get_it_on_Play_Store.79cae888.png";